import API from "../Common/Endpoint/serviceConstrants";
import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
export const pointApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(`${API.pointsApi}?ClientId=${payload}`);
  return data;
};